import { Badge } from "@jhool-io/fe-components";
import { removeEnumUnderscore } from "../../../utils/helpers";
import { RecurrenceRule } from "../../../utils/types";

export const getRecurrenceTag = (rule: RecurrenceRule) => {
    let bgColor: string;
    let textColor: string;

    switch (rule) {
        case RecurrenceRule.MONTHLY:
            bgColor = "#FEC7E2";
            textColor = "#712249";
            break;
        case RecurrenceRule.WEEKLY:
            bgColor = "#C6ECFF";
            textColor = "#205773";
            break;
        case RecurrenceRule.BIWEEKLY:
            bgColor = "#BAECD1";
            textColor = "#0E5730";
            break;
        case RecurrenceRule.ONE_OFF:
            bgColor = "#FEC1C6";
            textColor = "#711920";
            break;
        case RecurrenceRule.TRIWEEKLY:
            bgColor = "#D7C9FC";
            textColor = "#38256E";
            break;
        case RecurrenceRule.TWO_MONTHS:
            bgColor = "#FBDFBA";
            textColor = "#6D440E";
            break;
        case RecurrenceRule.THREE_MONTHS:
            bgColor = "#D3D5D9";
            textColor = "#33363B";
            break;
        default:
            bgColor = "#D3D5D9";
            textColor = "#33363B";
    }
    return (
        <Badge
            content={removeEnumUnderscore(rule)}
            textColor={textColor}
            bgColor={bgColor}
        />
    );
};
